export default "__VITE_ASSET__68926246__"